import { render, staticRenderFns } from "./CommunityQnaUpdate.vue?vue&type=template&id=9271438e"
import script from "./CommunityQnaUpdate.vue?vue&type=script&lang=js"
export * from "./CommunityQnaUpdate.vue?vue&type=script&lang=js"
import style0 from "./CommunityQnaUpdate.vue?vue&type=style&index=0&id=9271438e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports